import { Box, Paper, Typography } from "@mui/material";
import { ISetupChargeTotals } from "../../../shared/services/api/setupCharge/Types";
import { setupChargeFormatCurrency } from "../utils/setupChargeFormat";

interface SetupChargeTotalsProps {
	/** Totais do período e dos filtros em vigor; sem eles, os cartões ficam em branco. */
	totals?: ISetupChargeTotals;
}

export const SetupChargeTotals = ({ totals }: SetupChargeTotalsProps) => {
	const items = [
		{ label: "Quantidade", value: totals?.count !== undefined ? String(totals.count) : "" },
		{ label: "Valor cobrado", value: setupChargeFormatCurrency(totals?.amount) },
		{ label: "Líquido", value: setupChargeFormatCurrency(totals?.net) },
		{ label: "Repassado", value: setupChargeFormatCurrency(totals?.repassed) },
	];

	return (
		<Box display="flex" gap={2} flexWrap="wrap" mt={1} mx={1}>
			{items.map((item) => (
				<Paper key={item.label} variant="outlined" sx={{ px: 2, py: 1, minWidth: 150, borderRadius: 2 }}>
					<Typography variant="caption" color="textSecondary">
						{item.label}
					</Typography>
					<Typography variant="h6" fontWeight="bold">
						{item.value || "-"}
					</Typography>
				</Paper>
			))}
		</Box>
	);
};
